import { gql } from "@apollo/client";
import MultiValuesField from "controls/MultiValuesField";
import useIsAdmin from "hooks/useIsAdmin";
import SwitchInput from "inputs/SwitchInput";
import TextInput from "inputs/TextInput";
import React from "react";
import ReadminObjectInput from "readmin_pages/shared/ReadminObjectInput";
import ReadminObjectsInput from "readmin_pages/shared/ReadminObjectsInput";

export const TeamsFormFragment = gql`
  fragment TeamsFormFragment on Team {
    id
    name
    denyAccess
    videoRecordingPermitted
    aiStatsPermitted
    leagues {
      id
    }
  }
`;

export default function TeamsForm({ teams }) {
  const isAdmin = useIsAdmin();
  teams = teams?.map((team) => ({
    videoRecordingPermitted: true,
    aiStatsPermitted: true,
    ...team,
  }));

  return (
    <>
      {teams?.every((t) => !t.id) && (
        <MultiValuesField
          label="Organisation"
          name="org"
          defaultValues={teams?.map((t) => t.org)}
          required
          input={<ReadminObjectInput optionsTypename="Org" />}
        />
      )}
      <MultiValuesField
        label="Leagues"
        name="leagues"
        defaultValues={teams?.map((t) => t.leagues)}
        input={<ReadminObjectsInput optionsTypename="League" />}
      />
      <MultiValuesField
        label="Name"
        name="name"
        defaultValues={teams?.map((t) => t.name)}
        required
        input={<TextInput autoFocus />}
      />
      <MultiValuesField
        label="Deny Access"
        name="denyAccess"
        defaultValues={teams?.map((t) => t.denyAccess)}
        input={<SwitchInput />}
        helperText="Deny team members' access to game videos"
      />
      <MultiValuesField
        label="Video Recording Permitted"
        name="videoRecordingPermitted"
        defaultValues={teams?.map((t) => t.videoRecordingPermitted)}
        input={<SwitchInput />}
        helperText={
          <>
            Untick to disable videos for this team.
            <br />
            This feature is to be used when there are privacy concerns surrounding a player who can not be recorded. No
            video will be recorded or available for any future games of the team.
            <br />
            If you meant to disable a single game due to an incident, please do this from the game page and click the{" "}
            <b>Disable Video</b> button.
          </>
        }
      />
      {isAdmin && (
        <MultiValuesField
          label="AI Stats Permitted"
          name="aiStatsPermitted"
          defaultValues={teams?.map((t) => t.aiStatsPermitted)}
          input={<SwitchInput />}
          helperText={
            <>
              Untick if this team has opted out of AI stats.
              <br />
              AI stats cannot be purchased for any game this team plays in, including games that have already been
              recorded.
              <br />
              Games whose AI stats were already imported keep them — this does not remove existing stats.
            </>
          }
        />
      )}
    </>
  );
}
